import { render, staticRenderFns } from "./ProductDistributionDialog.vue?vue&type=template&id=34a1447d"
import script from "./ProductDistributionDialog.vue?vue&type=script&lang=js"
export * from "./ProductDistributionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports